import { convertFileToBase64 } from 'app/utils';
import axios from 'axios';

export type GetOwnerEmployersArgs = {
  ownerId: string;
  page?: number;
  itemsPerPage?: number;
  searchQuery?: string;
};

export type GetDeletedConnectionsArgs = {
  employerId: string;
  page?: number;
  itemsPerPage?: number;
};

export type RestoreConnectionArgs = {
  connectionId: string;
};

export type GetConnectionByIdArgs = {
  connectionId: string;
};

export type BulkLeftCompanyEmployee = {
  bsn: string;
  connectionId: string;
  startDate: string | null;
  endDate: string;
};

export type BulkLeftCompanyBackupResponse = {
  backupId: string;
  backupDate: string;
  employees: Array<{
    id: string;
    connectionId: string;
    bsn: string;
    startDateOfEmployment: string | null;
    endDateOfEmployment: string | null;
  }>;
  employments: Array<{
    id: string;
    startDate: string | null;
    endDate: string | null;
  }>;
  synchronizations: Array<{
    id: string;
    statusEmployee: boolean;
  }>;
};

export type FileUploadCleanupRequest = {
  connectionId: string;
  sinceDate: string;
};

export type UploadedFileDetail = {
  fileName: string;
  uploadedAt: string | null;
};

export type FileUploadCleanupPreviewResponse = {
  uploadedFiles: number;
  uploadedFileDetails: UploadedFileDetail[];
  employees: number;
  employments: number;
  addresses: number;
  runs: number;
  employeeComponentValues: number;
  wages: number;
  schedules: number;
  events: number;
  employeesWithSourceItemsToReset: number;
  synchronizations: number;
};

export const adminServices = {
  async getOwnerEmployers({ ownerId, page = 1, itemsPerPage = 30, searchQuery }: GetOwnerEmployersArgs) {
    return axios.get(`/admin/owners/${ownerId}/employers`, {
      params: { page, itemsPerPage, searchQuery },
    });
  },

  async getDeletedConnections({ employerId, page = 1, itemsPerPage = 30 }: GetDeletedConnectionsArgs) {
    return axios.get(`/admin/employers/${employerId}/deleted-connections`, {
      params: { page, itemsPerPage },
    });
  },

  async restoreConnection({ connectionId }: RestoreConnectionArgs) {
    return axios.put(`/admin/connections/${connectionId}/restore`, {});
  },

  async getConnectionById({ connectionId }: GetConnectionByIdArgs) {
    return axios.get(`/admin/connections/${connectionId}`);
  },

  async uploadNaverrekenenTemplate(file: File) {
    return axios.post(`tools/naverrekenen-template`, {
      parameters: {
        fileName: file.name,
      },
      base64FileContent: await convertFileToBase64(file),
    });
  },

  async bulkLeftCompanyBackup(employees: BulkLeftCompanyEmployee[]) {
    return axios.post<BulkLeftCompanyBackupResponse>(`/admin/employment-end-dates/backup`, { employees });
  },

  async bulkLeftCompanyUpdate(employees: BulkLeftCompanyEmployee[]) {
    return axios.post(`/admin/employment-end-dates/update`, { employees });
  },

  async undoUploadedFilePreview(data: FileUploadCleanupRequest) {
    return axios.post<FileUploadCleanupPreviewResponse>(`/admin/file-upload-cleanup/preview`, data);
  },

  async undoUploadedFileExecute(data: FileUploadCleanupRequest) {
    return axios.post(`/admin/file-upload-cleanup/execute`, data);
  },
};
